import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { FlexColumn } from 'components/Flex'
import text from 'styles/utility/text.module.scss'
import { Description } from 'components/Typography'
import { GreyButton } from 'components/Button'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import HTMLReactParser from 'html-react-parser'
import { returnCodeToBr } from 'lib/helper'

type Props = {
  headline: string
}

const RegisterCompleteTemplate: FC<Props> = (props) => {
  const { headline } = props
  const dispatch = useDispatch()
  return (
    <div className={styles.standard}>
      <Spacer size={48} />
      <FlexColumn alignItems={'center'}>
        <img src={'/icon/done/shop.svg'} alt={'アカウントの紐付けが完了しました'} />
        <Spacer size={16} />
        <h2 className={`${text.font_xxxlarge} ${text.align_center}`}>{HTMLReactParser(returnCodeToBr(headline))}</h2>
        <Spacer size={12} />
        <Description
          align={'center'}
          description={'登録したメールアドレスとパスワードで、\nログインを行ってください。'}
        />
      </FlexColumn>
      <Spacer size={48} />
      <GreyButton
        label={'ログインページへ'}
        onClick={() => dispatch(push('/login'))}
        size={'medium'}
        type={'outlined'}
      />
      <Spacer size={72} />
    </div>
  )
}

export default RegisterCompleteTemplate
